/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import ReactTable from 'react-table'
import createTable from 'react-table-hoc-fixed-columns'
import 'react-table/react-table.css'

import CSVExportModal from './CSVExportModal'
// import profile_avatar from '../../assets/images/mock/StockProfilePic.png'

const ReactTableFixedColumns = createTable(ReactTable)

class CommunityStatsTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      dataLoader: false,
      data: [],
    }
  }

  toggleModal = () => {
    this.setState({
      showModal: !this.state.showModal,
    })
  }

  createData = () => {
    const { data } = this.props
    const tempData = []
    this.setState({ dataLoader: true })
    if (data.length > 0) {
      data.map(info => {
        const community = info.community.name
        const totalfamilies = info.report.stats.family_count
        const totalstudents = info.report.stats.student_count
        const pointsearned = info.report.stats.points
        const totalactivities = info.report.stats.total_activities
        const totalpractices = info.report.stats.total_train_activities
        const totalsocialactions = info.report.stats.total_social_activities
        const goalscompleted = info.report.stats.total_goal_activities
        const rankscompleted = info.report.stats.ranks_completed
        const roundsplayed = info.report.stats.total_play_activities
        const strokeslost = info.report.stats.strokes_lost
        const enrolledstudents = info.report.stats.enrolled_students_count
        const notenrolledstudents = info.report.stats.not_enrolled_students_count

        tempData.push({
          community,
          totalfamilies,
          totalstudents,
          pointsearned,
          totalactivities,
          totalpractices,
          totalsocialactions,
          goalscompleted,
          rankscompleted,
          roundsplayed,
          strokeslost,
          enrolledstudents,
          notenrolledstudents,
        })
      })
    }

    this.setState({
      showModal: !this.state.showModal,
      data: tempData,
    })
  }

  renderUserAvatarCell = props => (
    <div
      className='number'
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <div className='small-round-image-wrapper'>
        <img
          className='round-image'
          src={props.value ? props.value.photo.file_url : ''}
          alt={
            props.value
              ? `${props.value.first_name} ${props.value.last_name}`
              : ''
          }
        />
      </div>
    </div>
  )
  renderTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: '#2b3843' }}>{props.value}</div>
    </div>
  )
  renderMainTableCell = props => (
    <div
      className='number'
      style={{
        backgroundColor: '#2b3843',
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div style={{ color: 'white' }}>{props.value}</div>
    </div>
  )
  renderTable = () => {
    const { loader, data, t } = this.props
    const columns = [
      {
        Header: '',
        accessor: 'community',
        Cell: props => this.renderUserAvatarCell(props),
        sortable: false,
        fixed: true,
      },
      {
        Header: t('reports.common.community'),
        accessor: 'community.name',
        Cell: props => this.renderTableCell(props),
        fixed: true,
      },
      {
        Header: t('reports.common.totalFamilies'),
        accessor: 'report.stats.family_count',
        Cell: props => this.renderMainTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalStudents'),
        accessor: 'report.stats.student_count',
        Cell: props => this.renderMainTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.pointsEarned'),
        accessor: 'report.stats.points',
        Cell: props => this.renderMainTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalActivities'),
        accessor: 'report.stats.total_activities',
        Cell: props => this.renderMainTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalPractices'),
        accessor: 'report.stats.total_train_activities',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.totalSocialActions'),
        accessor: 'report.stats.total_social_activities',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.goalsCompleted'),
        accessor: 'report.stats.total_goal_activities',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.communityStatsTable.levelsCompleted'),
        accessor: 'report.stats.ranks_completed',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.common.roundsPlayed'),
        accessor: 'report.stats.total_play_activities',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('common.golf.strokesLost'),
        accessor: 'report.stats.strokes_lost',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.communityStatsTable.enrolledStudents'),
        accessor: 'report.stats.enrolled_students_count',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
      {
        Header: t('reports.communityStatsTable.notEnrolledStudents'),
        accessor: 'report.stats.not_enrolled_students_count',
        Cell: props => this.renderTableCell(props),
        style: { padding: 0 },
      },
    ]

    return (
      <div className='container my-5 animated fadeIn'>
        <div className='row mb-5 d-flex align-items-center'>
          <div className='col-md-8'>
            <h2>{this.props.title}</h2>
          </div>
          <div className='col-md-4'>
            <button
              className='btn btn-sm btn-block'
              onClick={() => this.props.goBack()}
            >
              <i
                className='fa fa-arrow-left text-white mr-1'
                aria-hidden='true'
              />{' '}
              {t('reports.common.viewAnotherReport')}
            </button>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <ReactTableFixedColumns
              data={!loader ? data : []}
              columns={columns}
              defaultPageSize={3}
              loading={loader}
              previousText={t('reports.common.pagination.previous')}
              nextText={t('reports.common.pagination.next')}
              pageText={t('reports.common.pagination.page')}
              ofText={t('reports.common.pagination.of')}
              rowsText={t('reports.common.pagination.rows')}
              loadingText={t('reports.common.loadingReport')}
              noDataText={loader ? '' : t('reports.common.noDataFound')}
            />
          </div>
        </div>
        <button onClick={this.createData} className='mt-3 btn btn-success'>
          {t('reports.common.exportAsCsv')}
        </button>
      </div>
    )
  }

  render() {
    const { t } = this.props
    const headers = [
      { label: t('reports.common.community'), key: 'community' },
      { label: t('reports.common.totalFamilies'), key: 'totalfamilies' },
      { label: t('reports.common.totalStudents'), key: 'totalstudents' },
      { label: t('reports.common.pointsEarned'), key: 'pointsearned' },
      { label: t('reports.common.totalActivities'), key: 'totalactivities' },
      { label: t('reports.common.totalPractices'), key: 'totalpractices' },
      {
        label: t('reports.common.totalSocialActions'),
        key: 'totalsocialactions',
      },
      { label: t('reports.common.goalsCompleted'), key: 'goalscompleted' },
      {
        label: t('reports.communityStatsTable.levelsCompleted'),
        key: 'rankscompleted',
      },
      { label: t('reports.common.roundsPlayed'), key: 'roundsplayed' },
      { label: t('common.golf.strokesLost'), key: 'strokeslost' },
      {
        label: t('reports.communityStatsTable.enrolledStudents'),
        key: 'enrolledstudents',
      },
      {
        label: t('reports.communityStatsTable.notEnrolledStudents'),
        key: 'notenrolledstudents',
      },
    ]
    return (
      <div>
        {this.renderTable()}
        <CSVExportModal
          headers={headers}
          data={this.state.data}
          showModal={this.state.showModal}
          toggleModal={this.toggleModal}
          reportType={t('reports.communityStatsTable.reportType')}
          filename={'community-stats-report.csv'}
        />
      </div>
    )
  }
}

export default withTranslation()(CommunityStatsTable)
